module.exports = __webpack_public_path__ + "img/sparkling_heart.7605197f.gif";